import * as React from 'react';
import { Tabs, ITabProps } from '@cian/ui-kit/prev';
import { Layout } from '../Layout';
import * as styles from './About.css';

interface IAboutProps {
  title: React.ReactNode;
  tabs: ITabProps[];
  activeTab: string;
  onTabChange: (newTab: string) => void;
  tabContent: React.ReactNode;
}

export function About({ title, activeTab, tabContent, onTabChange, tabs }: IAboutProps) {
  return (
    <section className={styles['about']} id="about">
      <Layout>
        <div className={styles['about__wrapper']}>
          <div className={styles['about__title']}>{title}</div>

          <div className={styles['about__tabs']}>
            <Tabs tabs={tabs} onChange={onTabChange} activeTab={activeTab} />
          </div>

          {tabContent}
        </div>
      </Layout>
    </section>
  );
}
